import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitSelectionComponent } from './unit-selection.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {ReactiveFormsModule} from "@angular/forms";



@NgModule({
    declarations: [
        UnitSelectionComponent
    ],
    exports: [
        UnitSelectionComponent
    ],
    imports: [
        CommonModule,
        ChappsCommonAngularLibraryModule,
        ReactiveFormsModule
    ]
})
export class UnitSelectionModule { }
